// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220113/js/" + chunkId + "." + {"44":"a5ebb3f6","225":"e1f948c7","481":"673eebff","486":"2f3fc944","770":"060e4cea"}[chunkId] + ".0.11368661685359727.chunk.js";
};